import React from "react";
import {
  EmptyStateWrapper,
  EmptyStateIconWrapper,
  EmptyStateTextWrapper,
  EmptyStateTitle,
  EmptyStateDescription,
  EmptyStateButtonWrapper,
} from "./EmptyState.styles";
import { EmptyStateIcon } from "./EmptyStateIcon";
import { Button } from "../ButtonV2/Button";

export interface EmptyStateAction {
  label: string;
  onClick: () => void;
  bgColor?: string;
  textColor?: string;
}

export interface EmptyStateProps {
  title?: string;
  description?: string;
  titleColor?: string;
  descriptionColor?: string;
  action?: EmptyStateAction;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = "Nenhum resultado encontrado",
  description = "Tente ajustar os filtros ou realizar uma nova busca.",
  titleColor,
  descriptionColor,
  action,
}) => {
  return (
    <EmptyStateWrapper data-testid="empty-state">
      <EmptyStateIconWrapper>
        <EmptyStateIcon />
      </EmptyStateIconWrapper>

      <EmptyStateTextWrapper>
        <EmptyStateTitle color={titleColor}>{title}</EmptyStateTitle>
        <EmptyStateDescription color={descriptionColor}>
          {description}
        </EmptyStateDescription>
        {action && (
          <EmptyStateButtonWrapper>
            <Button
              type="button"
              size="small"
              className="styleguide"
              onClick={action.onClick}
              palette={{
                bgColor: action.bgColor,
                textColor: action.textColor,
              }}
            >
              {action.label}
            </Button>
          </EmptyStateButtonWrapper>
        )}
      </EmptyStateTextWrapper>
    </EmptyStateWrapper>
  );
};
